import { render, staticRenderFns } from "./CoreTeam.vue?vue&type=template&id=8109e538&scoped=true&"
import script from "./CoreTeam.vue?vue&type=script&lang=js&"
export * from "./CoreTeam.vue?vue&type=script&lang=js&"
import style0 from "./CoreTeam.vue?vue&type=style&index=0&id=8109e538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8109e538",
  null
  
)

export default component.exports